import Settings from '@/config/Settings'

export default {
  data: () => ({
    $prevLeave: null
  }),
  computed: {
    mode() {
      return this.$store.getters['app/mode']
    }
  },
  beforeCreate() {
    this.$router.beforeEach((to, redirect, next) => {
      this.$store.commit('app/SET_FROM_ROUTE', this.$route)
      if(this.$refs.page)
        this.$prevLeave = this.$refs.page.leave

      if(this.$root.isDev)
        return next()

      if(redirect.params.page)
        return next()

      if(redirect.meta.name == 'artwork' && redirect.params.id)
        return next()

      // if(redirect.params.slug == 'twinning')
      //   return next()

      if(to.meta.name == 'artwork')
        return next()

      const index = {
        to: this.scenario.indexOf(to.params.slug),
        from: this.scenario.indexOf(redirect.params.slug),
      }

      if(index.from > index.to)
        return this.showExit(next, redirect)

      next()
    })

    this.$router.afterEach(to => {
      this.$store.commit('app/SET_TO_ROUTE', to)

      if(typeof ga === 'function')
        ga('send', 'pageview', location.pathname)

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ page: undefined })
      window.dataLayer.push({
        event: 'pageChange',
        page: {
          uri: location.pathname,
          title: window.title
        }
      })

      if(this.lang != to.meta.lang)
        this.$store.commit('app/LANG_CHANGED', to.meta.lang)

      this.$root.setLangRouteNames()
    })
  },
  methods: {
		showExit(next, from) {
      this.$refs.backmessage.show().then(() => {
        next()
        this.$router.push({ name: 'museum.' + this.lang, params: { slug: 'introduction' } })
      }).catch(() => {
        next()
        this.$router.push({ name: from.name, params: from.params })
      })
    },
    afterEnter() {
      if(this.mode == 'in-out' && this.mode != Settings.mode)
        this.$store.commit('app/RESET_MODE')
    },
    afterLeave() {
      if(this.mode == 'out-in' || this.mode == '' && this.mode != Settings.mode)
        this.$store.commit('app/RESET_MODE')
    },
    beforeEnter() {
      window.scrollTo(0,0)
    },
    enter(el, done) {
      this.$refs.page.enter
      ? this.$refs.page.enter(done)
      : TweenMax.from(el, .5, { alpha: 0, onComplete: done })
    },
    leave(el, done) {
      this.$prevLeave
      ? this.$prevLeave(done)
      : TweenMax.to(el, .5, { alpha: 0, onComplete: done })
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/mixins/Transition.js